// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cards_wrapper__1dNmy","title":"cards_title__4G7Mz","card":"cards_card__2FwzJ","gridContainer":"cards_gridContainer__1b6x-","theGrid":"cards_theGrid__214SC"};